import { render } from "./NewFitKit.vue?vue&type=template&id=0e62f6ec&scoped=true&lang=pug"
import script from "./NewFitKit.vue?vue&type=script&lang=js"
export * from "./NewFitKit.vue?vue&type=script&lang=js"

import "./NewFitKit.vue?vue&type=style&index=0&id=0e62f6ec&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e62f6ec"]])

export default __exports__